import { MsalAuthenticationResult } from '@azure/msal-react';
import { useEffect } from 'react';
import { MemoryRouter } from 'react-router-dom';

import ErrorUnauthenticatedPage from 'pages/errors/ErrorUnauthenticatedPage';

import {
	hasRetriedMsalAuthentication,
	retryMsalAuthentication,
} from './MsalAuthenticationRetry';
import { reportMsalError } from './MsalErrorReporter';
import { AuthProviderStorage } from './Storage';

// Rendered by MsalAuthenticationTemplate above the app router,
// so the error page needs its own router context.
export const MsalAuthenticationError = ({
	error,
}: MsalAuthenticationResult): React.JSX.Element => {
	useEffect(() => {
		if (error) {
			reportMsalError(error, 'MsalAuthenticationTemplate');
		}
	}, [error]);

	// MsalAuthenticationTemplate keeps its error state, so recovering
	// requires a full page load. Retry only once to avoid reload loops.
	useEffect(() => {
		if (hasRetriedMsalAuthentication()) {
			return;
		}

		let isCancelled = false;
		void AuthProviderStorage.getInstance()
			?.getProvider()
			.isAuthenticated()
			.then((isAuthenticated) => {
				if (
					isCancelled ||
					!isAuthenticated ||
					hasRetriedMsalAuthentication()
				) {
					return;
				}
				retryMsalAuthentication();
			});

		return () => {
			isCancelled = true;
		};
	}, []);

	return (
		<MemoryRouter>
			<ErrorUnauthenticatedPage />
		</MemoryRouter>
	);
};
